// HomeWeb.jsx
import React , {useEffect} from 'react';
import { Text, ScrollView, View, Image, TouchableOpacity, Platform, Linking } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import BaseWeb from './components/baseWeb';
import styles from './styles/celerWebStyles';
import { useLogScreen } from '../useLogScreen';
export default function GeradorDeContratosWeb() {
    useLogScreen('GeradorContratos');
    useEffect(() => {
        if (Platform.OS === 'web') {
            setTimeout(() => {
                document.title = 'imoGo | Gerador de Contratos';
            }, 100);
        }
    }, []);
    const navigation = useNavigation();

    return (
        <BaseWeb>
            {(userInfo) => {
                const usuario_id = userInfo?.id;
                const email_solicitante = userInfo?.email;
                return (
                    <ScrollView contentContainerStyle={styles.contentMinimal}>
                        <Text style={styles.title}>Gerador de Contratos</Text>

                        <View style={styles.container}>

                            <View style={styles.row}>
                                <Text style={styles.checkboxLabel} allowFontScaling={false}>
                                    O gerador de contratos da imoGo é uma funcionalidade desenvolvida para automatizar a criação de documentos essenciais no processo de compra e venda de imóveis.
                                </Text>
                            </View>

                            <View style={styles.row}>
                                <View style={styles.optionButtonsContainer}>                                    
                                    <TouchableOpacity style={styles.optionButton} onPress={() => navigation.navigate('AutorizacaoDeVendaWeb', { usuario_id, emailUser: email_solicitante })}>
                                        <Image
                                            source={require('../assets/icons/files.png')}
                                            style={styles.optionIcon}
                                        />
                                        <View style={styles.optionTextContainer}>
                                            <Text style={styles.optionTextTitle} allowFontScaling={false}>Autorização de Venda</Text>
                                        </View>
                                    </TouchableOpacity>
                                    <TouchableOpacity style={styles.optionButton} onPress={() => navigation.navigate('EtapasCorretagemWeb', { usuario_id, email_solicitante })}>
                                        <Image
                                            source={require('../assets/icons/files.png')}
                                            style={styles.optionIcon}
                                        />
                                        <View style={styles.optionTextContainer}>
                                            <Text style={styles.optionTextTitle} allowFontScaling={false}>Contrato de corretagem</Text>
                                        </View>
                                    </TouchableOpacity>
                                    {/* <TouchableOpacity style={styles.optionButton} onPress={() => navigation.navigate('MeusProjetos', { usuario_id })}>
                                        <Image
                                            source={require('../assets/icons/files.png')}
                                            style={styles.optionIcon}
                                        />
                                        <View style={styles.optionTextContainer}>
                                            <Text style={styles.optionTextTitle} allowFontScaling={false}>Avaliação de experiência do cliente</Text>
                                        </View>
                                    </TouchableOpacity> */}
                                    <TouchableOpacity style={styles.optionButton} onPress={() => navigation.navigate('EtapasPromessaWeb', { usuario_id, email_solicitante })}>
                                        <Image
                                            source={require('../assets/icons/files.png')}
                                            style={styles.optionIcon}
                                        />
                                        <View style={styles.optionTextContainer}>
                                            <Text style={styles.optionTextTitle} allowFontScaling={false}>Contrato de promessa de compra e venda</Text>
                                        </View>
                                    </TouchableOpacity>
                                </View>
                            </View>

                            <View style={styles.buttonContainer}>
                                <TouchableOpacity style={styles.laterButton} onPress={() => navigation.navigate('Home', { usuario_id })}>
                                    <Image
                                        source={require('../assets/icons/home.png')}
                                        style={styles.laterIcon}
                                    />
                                    <Text style={styles.laterButtonText} allowFontScaling={false}>Voltar pra home</Text>
                                </TouchableOpacity>
                            </View>
                        </View>
                    </ScrollView>
                );
            }}
        </BaseWeb>
    );
}